
interface DirectoryHeroProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  totalResults: number;
}

export default function DirectoryHero({ searchQuery, onSearchChange, totalResults }: DirectoryHeroProps) {
  return (
    <section className="relative pt-28 pb-16 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/258c93d9e57a8346d4842baff6838c52.jpg"
          alt="Roseville California business district aerial view"
          title="Roseville CA Business Directory"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 via-gray-900/60 to-gray-900/80"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
            <i className="ri-store-2-line text-white text-lg"></i>
          </div>
          <span className="text-amber-400 font-semibold text-sm uppercase tracking-wider">
            Roseville Business Directory
          </span>
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
          Discover <span className="text-amber-400">Local Businesses</span>
        </h1>
        <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
          Find trusted businesses, read reviews, and connect with the best services Roseville and Placer County have to offer.
        </p>

        <div className="max-w-2xl mx-auto">
          <div className="relative">
            <div className="absolute left-5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400 text-lg"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search by business name, category, or service..."
              className="w-full pl-14 pr-5 py-4 rounded-full bg-white text-sm text-gray-900 placeholder-gray-400 shadow-xl focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
            {searchQuery && (
              <button
                onClick={() => onSearchChange('')}
                className="absolute right-5 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            )}
          </div>
        </div>

        <p className="text-white/60 text-sm mt-4">
          Showing <strong className="text-white">{totalResults}</strong> businesses in Roseville, CA
        </p>
      </div>
    </section>
  );
}
